import { render, staticRenderFns } from "./book.vue?vue&type=template&id=ec6f86ce&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec6f86ce')) {
      api.createRecord('ec6f86ce', component.options)
    } else {
      api.reload('ec6f86ce', component.options)
    }
    module.hot.accept("./book.vue?vue&type=template&id=ec6f86ce&", function () {
      api.rerender('ec6f86ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/book.vue"
export default component.exports